/* eslint-disable camelcase */
import Vue from 'vue';
import qs from 'qs';
import { cloneDeep } from 'lodash';
import dayjs from 'dayjs';

import LINE6_STATION_LIST from '@/app/constant/LINE6_STATION_LIST.json';

function getPreviewEl (el) {
    const previewElClass = 'v-md-editor-preview';

    return el.classList.contains(previewElClass) ? el : el.querySelector(`.${previewElClass}`);
}

export default function createPlugin () {
    async function handleMdChange () {
        if (typeof window === 'undefined') return;

        await this.$nextTick();

        const previewEl = getPreviewEl(this.$el);
        const eles = previewEl.querySelectorAll('.v-md-pre-wrapper-gpt-chatbox-flow-simulation');
        if (!eles.length) return;

        let ele = eles[0];
        if (!ele || !ele.innerText) return;

        try {
            let text = ele.innerText;
            ele.innerText = '';

            let url = text.trim();
            let query = qs.parse(url.substring(url.indexOf('?') + 1));
            let headers = { 'Content-Type': 'application/json' };
            let body = JSON.stringify({
                'direction': query.direction || 'down',
                'day': query.day || '2022-09-19',
                'flow_factor': query.flow_factor || '1'
            });
            let resp = await fetch(url, { method: 'POST', body, headers });
            let json = await resp.json();

            if (!json) {
                ele.innerText = '未识别数据';
                return;
            }

            let locationId = query.location_id;
            let compName = null;
            let data = null;

            let stations = [];
            let station = LINE6_STATION_LIST.find((item) => {
                return item.id === locationId;
            });
            if (station) {
                // 单个站点
                stations = [station];
            } else {
                // 所有站点
                stations = cloneDeep(LINE6_STATION_LIST);
            }

            data = [];
            stations.forEach((station) => {
                let no = parseInt(station.id) - 60;
                let platform = json['platform profiles'][no];
                let list = platform['waiting passenger number'].map((val, idx) => {
                    if (!val || val < 0)val = 0;
                    let hhmm = dayjs((6 - 8) * 60 * 60 * 1000 + idx * 180 * 1000).format('HH:mm');
                    return { 'SERIES': station.name, 'CATEGORY': hhmm, 'VALUE': parseInt(val) };
                });
                data = data.concat(list);
            });
            compName = 'gpt-' + query.chartType;

            if (data && compName) {
                let propsData = { value: data };// 组件初始化时传入绑定数据（propsData只能用于初始化，复发响应式）

                let Comp = Vue.component(compName);
                if (!Comp) {
                    throw new Error(`Component ${compName} not found`);
                }
                let comp = new Comp({ propsData });
                comp.$mount(ele);
            } else {
                ele.innerText = '未识别数据';
            }
        } catch (err) {
            console.error(err);
            ele.innerText = '分析过程中出现错误';
        }
    }

    return {
        install (VMdEditor) {
            if (!VMdEditor.mixins) VMdEditor.mixins = [];

            VMdEditor.mixins.push({
                watch: {
                    value: {
                        immediate: true,
                        handler: handleMdChange
                    },
                    text: {
                        immediate: true,
                        handler: handleMdChange
                    },
                    currentMode: handleMdChange
                }
            });
        }
    };
};
